import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const getReportNames = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/report/names`,
    );
    return response.data.map((item) => ({
      key: item.reportId,
      text: item.reportAlias,
      value: item.reportSchema,
      schema: item.reportSchemaId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const submitReportRequest = async (
  reportId,
  params,
  forceRegeneration = false,
) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/request/${reportId}/submit`,
      {
        params,
        forceRegeneration,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Report submit failed", error);
    throw error;
  }
};

export const searchReportQueue = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/request/queue`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Report queue search failed", error);
    throw error;
  }
};

export const approveReport = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/v1/report/approval`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Report approval failed", error);
    throw error;
  }
};

export const cancelReport = async (requestId) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/request/${requestId}/cancel`,
    );

    return response.data;
  } catch (error) {
    console.error("Report cancel failed", error);
    throw error;
  }
};

export const getReportDownloadInfo = async (requestId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/request/download/${requestId}`,
    );

    return response.data;
  } catch (error) {
    console.error("Report download failed", error);
    throw error;
  }
};

export const downloadFile = async (docId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/s3/download`,
      {
        params: { docId },
      },
    );

    return response.data;
  } catch (error) {
    console.error("File download failed", error);
    throw error;
  }
};

export const getReportField = async (schemaId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/rule/field/${schemaId}`,
    );
    const reportData = response.data?.reportData || [];
    return reportData.map((item) => ({
      key: item.scfId,
      text: item.scfName,
      value: item.scfId,
      field: item.scfField,
      copType: item.copType,
      copParams: item.copParams,
      copEndpoint: item.copEndpoint,
      copLiveFetch: item.copLiveFetch,
      copFieldInfo: item.copFieldInfo,
      isMultiple: item.isMultiple,
    }));
  } catch (error) {
    console.log("error get fields", error);
    throw error;
  }
};

export const getReportRule = async (reportId, field) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/rule/definition/${reportId}/${field}`,
    );
    const reportData = response.data?.reportData || [];
    return reportData.map((item) => ({
      key: item.ruleDefId,
      text: item.ruleName,
      value: item.ruleDefId,
      dataType: item.dataType,
      operatorType: item.operatorType,
    }));
  } catch (error) {
    console.log("error get rules", error);
    throw error;
  }
};

export const searchRule = async (request) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/rule/search`,
      request,
    );
    return response.data;
  } catch (error) {
    console.log("error get search", error);
    throw error;
  }
};
export const getReportById = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/report/names`,
    );
    return response.data.map((item) => ({
      key: item.reportId,
      text: item.reportAlias,
      value: item.reportId,
      schema: item.reportSchemaId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const createRule = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/rule/assignment`,
      payload,
    );
    return response.data?.reportRuleAssignment;
  } catch (error) {
    console.log("error create rule", error);
    throw error;
  }
};

export const getRuleAssignment = async (assignmentId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.REPORT}/v1/reports/rule/${assignmentId}`,
    );
    return response.data;
  } catch (error) {
    console.log("error get rule", error);
    throw error;
  }
};
